import {GalleryItem} from "../Gallery";

export const gallery2026Items: GalleryItem[] = [

];
